import { Switch } from "@headlessui/react";
import React from "react";
import { Typography } from "../../../../../../../core/components/molecules/Typography";

interface ITaskSwitch {
  showIncompleteTasks: boolean;
  setShowIncompleteTasks: (showIncompleteTasks: boolean) => void;
}

const TaskSwitch: React.FC<ITaskSwitch> = ({ showIncompleteTasks, setShowIncompleteTasks }) => {
  return (
    <div data-tour="incomplete-tasks-toggle" className="flex flex-row items-center gap-2">
      <Switch
        checked={showIncompleteTasks}
        onChange={() => setShowIncompleteTasks(!showIncompleteTasks)}
        className={`
          group relative flex items-center h-5 w-10 cursor-pointer rounded-pill 
          ${showIncompleteTasks ? 'bg-feedback-color-success-pure' : 'bg-mono-color-medium'} 
          p-0.5 ease-in-out focus:outline-none focus-visible:ring-0
        `}
      >
        <span className={`w-3 h-3 rounded-pill bg-mono-color-white transition ${showIncompleteTasks ? 'translate-x-5' : 'translate-x-1'}`} />
      </Switch>
      <Typography size="small">Mostrar tarefas incompletas</Typography>
    </div>
  );
};

export default TaskSwitch;